import React, { useEffect, useRef, useState } from 'react';
import BeatList from './BeatList';
import styles from './ChooseYourBeatContent.module.css';
import SearchModal from './SearchModal';
import backIcon from "../icons/back_icn.png";
import searchIcon from "../icons/search_beat.png";
import closeIcon  from '../icons/search_close.png';

const ChooseYourBeatContent = ({ onBack, isAuthenticated, sendEvent }) => {
  const contentRef = useRef(null);
  const scrollInterval = useRef(null);
  const [highlightedBeatId, setHighlightedBeatId] = useState(null);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const beatId = params.get('beatId');
        if (beatId) {
          setHighlightedBeatId(Number(beatId));
        }
        window.history.replaceState(null, '', '/');
  }, []);

  useEffect(() => {
    const content = contentRef.current;

    if (content) {
      let scrollStep = 1;

      const startAutoScroll = () => {
        scrollInterval.current = setInterval(() => {
          if (content.scrollTop + content.clientHeight >= content.scrollHeight) {
            clearInterval(scrollInterval.current);
	    scrollInterval.current = null;
          } else {
            content.scrollTop += scrollStep;
          }
        }, 50);
      };

      startAutoScroll();

      const stopAutoScroll = () => {
        clearInterval(scrollInterval.current);
	scrollInterval.current = null;
        content.removeEventListener('wheel', stopAutoScroll, { passive: true });
        content.removeEventListener('touchstart', stopAutoScroll, { passive: true });
      };

      content.addEventListener('wheel', stopAutoScroll, { passive: true });
      content.addEventListener('touchstart', stopAutoScroll, { passive: true });

      return () => {
        content.removeEventListener('wheel', stopAutoScroll, { passive: true });
        content.removeEventListener('touchstart', stopAutoScroll, { passive: true });
        clearInterval(scrollInterval.current);
      };
    }
  }, []);

  const restartAutoScroll = () => {
    const content = contentRef.current;
    if (!content) return;

    clearInterval(scrollInterval.current);
    scrollInterval.current = null;

    const stop = () => {
      clearInterval(scrollInterval.current);
      scrollInterval.current = null;
      content.removeEventListener('wheel', stop, { passive: true });
      content.removeEventListener('touchstart', stop, { passive: true });
    };

    content.scrollTop = 0;
    let scrollStep = 1;
    scrollInterval.current = setInterval(() => {
      if (content.scrollTop + content.clientHeight >= content.scrollHeight) {
        stop();
      } else {
        content.scrollTop += scrollStep;
      }
    }, 50);

    content.addEventListener('wheel', stop, { passive: true });
    content.addEventListener('touchstart', stop, { passive: true });
  };

  const handleSearchIconClick = () => {
    if (searchQuery) {
        setSearchQuery('');
        if (!scrollInterval.current) {
        restartAutoScroll();
      } else {
        const c = contentRef.current;
        c && c.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } else {
      setShowSearch(true);
    }
  };

  return (
    <div className={styles.chooseYourBeatContentContainer}>
      <img
        src={backIcon}
        alt="Back"
        className={`${styles.backIcon} ${styles.visible}`}
        onClick={onBack}
      />

      <img
        src={searchQuery ? closeIcon : searchIcon}
        alt={searchQuery ? 'Clear search' : 'Search'}
        className={`${styles.searchIcon} ${styles.visible}`}
        onClick={handleSearchIconClick}
      />

      <h1 className={styles.pageTitle}>Choose Your Beat</h1>

      <div className={styles.chooseYourBeatContent} ref={contentRef}>
       <BeatList
        highlightedBeatId={highlightedBeatId}
        restartAutoScroll={restartAutoScroll}
        isAuthenticated={isAuthenticated}
	sendEvent={sendEvent}
	searchQuery={searchQuery}
       />
	
        {showSearch && (
          <SearchModal
            onClose={() => setShowSearch(false)}
            onSubmit={q => {
              setSearchQuery(q.trim());
              setShowSearch(false);
            }}
          />
       )}
      </div>
    </div>
  );
};

export default ChooseYourBeatContent;

